import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import axios from 'axios';
import { PlusCircle } from 'feather-icons-react/build/IconComponents';
import { Filter } from 'react-feather';
import AddCoupons from '../../core/modals/coupons/addcoupons';
import EditCoupons from '../../core/modals/coupons/editcoupons';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

const Coupons = () => {
    const MySwal = withReactContent(Swal);

    const [coupons, setCoupons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [isFilterVisible, setIsFilterVisible] = useState(false);

    useEffect(() => {
        fetchCoupons();
    }, []);

    const fetchCoupons = async () => {
        setLoading(true);
        try {
            const res = await axios.get("https://avastar-pos-backend.onrender.com/api/coupons");
            setCoupons(res.data);
        } catch (error) {
            console.error("Error fetching coupons:", error);
        } finally {
            setLoading(false);
        }
    };

    const deleteCoupon = async (id) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            showCancelButton: true,
            confirmButtonColor: '#00ff00',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#ff0000',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(`https://avastar-pos-backend.onrender.com/api/coupons/${id}`);
                    setCoupons(coupons.filter(c => c._id !== id));
                    MySwal.fire('Deleted!', 'Coupon has been deleted.', 'success');
                } catch (error) {
                    MySwal.fire('Error', 'Failed to delete coupon', 'error');
                }
            }
        });
    };

    const toggleFilterVisibility = () => setIsFilterVisible(!isFilterVisible);

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4>Coupons</h4>
                            <h6>Manage Your Restaurant Coupons</h6>
                        </div>
                    </div>
                    <div className="page-btn">
                        <Link to="#" className="btn btn-added" data-bs-toggle="modal" data-bs-target="#add-units">
                            <PlusCircle className="me-2"/>
                            Add New Coupon
                        </Link>
                    </div>
                </div>

                <div className="card table-list-card">
                    <div className="card-body">
                        <div className="table-top">
                            <div className="search-set">
                                <div className="search-input">
                                    <input type="text" placeholder="Search Coupons" className="form-control form-control-sm formsearch" />
                                </div>
                            </div>
                            <div className="search-path">
                                <Link className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`} id="filter_search" onClick={toggleFilterVisibility}>
                                    <Filter className="filter-icon" />
                                </Link>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table datanew">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Code</th>
                                        <th>Type</th>
                                        <th>Discount</th>
                                        <th>Limit</th>
                                        <th>Used</th>
                                        <th>Valid Until</th>
                                        <th>Status</th>
                                        <th className="no-sort">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr><td colSpan="9" className="text-center">Loading...</td></tr>
                                    ) : coupons.length === 0 ? (
                                        <tr><td colSpan="9" className="text-center">No coupons found</td></tr>
                                    ) : coupons.map((coupon) => (
                                        <tr key={coupon._id}>
                                            <td>{coupon.name}</td>
                                            <td><span className="badge bg-danger">{coupon.code}</span></td>
                                            <td>{coupon.type}</td>
                                            <td>{coupon.type === 'Percentage' ? `${coupon.discount}%` : `LKR ${coupon.discount}`}</td>
                                            <td>{coupon.limit === 0 ? 'Unlimited' : coupon.limit}</td>
                                            <td>{coupon.usedCount}</td>
                                            <td>{new Date(coupon.validUntil).toLocaleDateString()}</td>
                                            <td>
                                                <span className={`badge ${coupon.isActive ? 'badge-linesuccess' : 'badge-linedanger'}`}>
                                                    {coupon.isActive ? 'Active' : 'Inactive'}
                                                </span>
                                            </td>
                                            <td className="action-table-data">
                                                <div className="edit-delete-action">
                                                    <Link className="me-2 p-2" to="#" data-bs-toggle="modal" data-bs-target="#edit-units" onClick={() => setSelectedCoupon(coupon)}>
                                                        <i className="fas fa-edit"></i>
                                                    </Link>
                                                    <Link className="confirm-text p-2" to="#" onClick={() => deleteCoupon(coupon._id)}>
                                                        <i className="fas fa-trash-alt"></i>
                                                    </Link>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <AddCoupons onRefresh={fetchCoupons} />
            <EditCoupons coupon={selectedCoupon} onRefresh={fetchCoupons} />
        </div>
    )
}

export default Coupons
